export const API_URL = process.env.REACT_APP_BACKEND_URL;

export const formatNumericValue = (value) => {
  if (value === "" || value === null || value === undefined || value === 0) return "";
  const num = parseFloat(value);
  return isNaN(num) ? "" : num.toString();
};

export const stageConfig = {
  LEAD: { label: "Lead", color: "bg-slate-500", textColor: "text-slate-300" },
  CONTACTADO: { label: "Contactado", color: "bg-[#03BEE4]", textColor: "text-[#03BEE4]" },
  PROPUESTA: { label: "Propuesta", color: "bg-yellow-500", textColor: "text-yellow-400" },
  NEGOCIACION: { label: "Negociación", color: "bg-purple-500", textColor: "text-purple-400" },
  GANADA: { label: "Ganada", color: "bg-[#42E695]", textColor: "text-[#42E695]" },
  PERDIDA: { label: "Perdida", color: "bg-red-500", textColor: "text-red-400" },
};

export const activePipelineStages = ["LEAD", "CONTACTADO", "PROPUESTA", "NEGOCIACION"];

export const proximaAccionOptions = [
  "Enviar propuesta formal por correo",
  "Espera de oferta más viable",
  "Llamar para seguimiento",
  "Coordinar reunión presencial",
  "Programar demo del producto",
  "Otro",
];
